import { Outlet } from 'react-router-dom';
import SideBar from './components/SideBar';
import HeaderBar from './components/HeaderBar';
import { ContentContainer, Root } from './style';

export default function MainPage() {
  return (
    <>
      <HeaderBar />
      <Root>
        <SideBar />
        <ContentContainer>
          <Outlet />
        </ContentContainer>
      </Root>
    </>
  );
}
